// <pos-menu-item/> — 單個菜單品項（tile）
// 點擊 → 加入購物車
// see architecture.md#L580

import { addToCart } from '../lib/state/cart.js';
import { escapeHtml } from '../lib/utils/escape.js';

class PosMenuItem extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.render();
    this.shadowRoot.querySelector('.tile').addEventListener('click', () => this.onClick());
  }

  render() {
    const name = this.dataset.name || '—';
    const price = this.dataset.price || '0';
    const desc = this.dataset.desc || '';
    this.shadowRoot.innerHTML = `
      <style>
        :host { display: block; }
        .tile {
          aspect-ratio: 1 / 1;
          min-height: 80px;
          padding: var(--s-3);
          background: var(--bg-surface);
          border: 1px solid var(--border);
          border-radius: var(--r-md);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          cursor: pointer;
          transition: transform var(--dur-fast) var(--ease);
          user-select: none;
        }
        .tile:active { transform: scale(0.95); }
        .name { font-size: 14px; font-weight: 500; }
        .desc { font-size: 11px; color: var(--fg-muted); overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; line-height: 1.4; }
        .price { color: var(--brand-primary); font-weight: 600; }
      </style>
      <div class="tile">
        <div class="name">${escapeHtml(name)}</div>
        ${desc ? `<div class="desc">${desc}</div>` : ''}
        <div class="price">NT$ ${escapeHtml(price)}</div>
      </div>
    `;
  }

  onClick() {
    addToCart({
      menu_item_id: this.dataset.id,
      name: this.dataset.name,
      price: Number(this.dataset.price),
      qty: 1,
    });
    // 視覺回饋
    this.shadowRoot.querySelector('.tile').animate(
      [{ transform: 'scale(1)' }, { transform: 'scale(0.9)' }, { transform: 'scale(1)' }],
      { duration: 200, easing: 'ease-out' }
    );
  }
}

customElements.define('pos-menu-item', PosMenuItem);
